module.exports = __webpack_public_path__ + "static/media/croizat.f6733c6f.png";